<template>
    <div id="moduleAppList">
        <div class="top">
            <el-button size="medium" type="primary" v-if="isShowByPermission('/wyms/roleInfo/insertRoleInfo')" @click="jumpToPage('roleAddEdit')">新建</el-button>
            <el-button size="medium" type="danger" v-if="isShowByPermission('/wyms/roleInfo/deleteRoleInfo')" @click="batchDeleteHandler">删除</el-button>
            <el-input size="medium" class="search-input search-input--right" placeholder="角色名称"
                      v-model="roleInfoName" @keyup.enter.native="getList">
                <el-button slot="append" icon="el-icon-search" size="medium" @click="getList"></el-button>
            </el-input>
        </div>
        <div >
            <el-table
                :height="windowHeight - 220"
                :data="dataList"
                style="width: 100%" border
                @selection-change="handleSelectionChange"
            >
                <el-table-column
                    type="selection"
                    width="55">
                </el-table-column>
                <el-table-column
                    label="常量标识"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.constantId }}
                    </template>

                </el-table-column>
                <el-table-column
                    label="名称"
                    prop="name"
                    align="center"
                >
                </el-table-column>
                <el-table-column
                    label="是否可选"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ ['', '可选', '不可选', '不可选但默认'][scope.row.isChoose] }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="是否可删除"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ ['', '可删', '不可删'][scope.row.ynDelete] }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="平台"
                    align="center"
                >
                    <template slot-scope="scope">
                        {{ scope.row.platformTypeName }}
                    </template>
                </el-table-column>
                <el-table-column
                    label="操作"
                    align="center"
                >
                    <template slot-scope="scope">
                        <el-button type="text" v-if="isShowByPermission('/wyms/roleInfo/updateRoleInfoZ')" @click="jumpToPage('roleAddEdit', {id: scope.row.id})">编辑</el-button>
                        <el-button type="text" v-if="isShowByPermission('/wyms/roleInfo/deleteRoleInfo')" @click="deleteHandler(scope.row.id)">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-container">
                <el-pagination
                    @size-change="sizeChangeHandler"
                    @current-change="currentChangeHandler"
                    :current-page.sync="pagination.pageNo"
                    :page-sizes="[10 , 20, 30, 50]"
                    :page-size.sync="pagination.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :page-count="pagination.pages"
                    :total="pagination.total"
                >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    import {isShowByPermission} from "@/utils/utils";

    import windowResize from '@/mixins/windowResize';
    import baseMixin from '@/mixins/baseMixin';
    import {
        deleteRoleInfo,
        queryRoleInfoList
    } from '@/api/role';
    export default {
        name: "roleList",
        data() {
            return {
                roleInfoName: '',
                dataList: [],
                multipleSelection:[],
            }
        },
        activated() {
            this.queryRoleInfoListFunc()

        },
        created() {
            this.queryRoleInfoListFunc()

        },
        mixins: [windowResize, baseMixin],
        methods: {
            isShowByPermission,
            getList() {
                this.pagination.pageNo = 1;
                this.queryRoleInfoListFunc();
            },
            handleSelectionChange(val){
                this.multipleSelection = val;
            },
            sizeChangeHandler() {
                this.queryRoleInfoListFunc();
            },
            currentChangeHandler() {
                this.queryRoleInfoListFunc();
            },
            batchDeleteHandler() {
                if(this.multipleSelection.length === 0) {
                    this.$message.error('请选择要删除的角色');
                } else {
                    this.deleteHandler(this.multipleSelection.map(({id}) => id).join(','));
                }
            },
            deleteHandler(ids) {
                this.$confirm("确认要删除吗？", "删除", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    lockScroll: false
                }).then(() => {
                    deleteRoleInfo({
                        ids
                    })
                        .then(() => {
                            this.queryRoleInfoListFunc();
                        })
                });
            },
            queryRoleInfoListFunc() {
                queryRoleInfoList({
                    roleInfoName: this.roleInfoName,
                    pageNo: this.pagination.pageNo,
                    pageSize: this.pagination.pageSize
                })
                    .then(data => {
                        this.dataList = data.dataList;
                        this.pagination.total = data.pagination.total;
                    })
            }
        }
    }
</script>

<style lang="scss">
    #moduleAppList {
        padding:12px;
        a {
            color: #409EFF;
        }
        .top{
            padding-bottom:10px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/permissionSystem/role/roleList.vue